export default __webpack_public_path__ + "static/after1-e4f4bc0170bb7c28e7787aa91fff4c50.jpg";